import { account } from "utils/axiosInstances";
import { camelize } from "utils/objectUtilities";

const URL = "/orders/schedule";

export type GetOrdersScheduleParams = { date: string; brigade: number | null };

export const getOrdersSchedule = async ({ date, brigade }: GetOrdersScheduleParams) => {
  try {
    const response = await account.get(`${URL}?date=${date}${brigade ? `&brigade=${brigade}` : ""}`);
    return camelize(response, true);
  } catch (error) {
    // @ts-expect-error TODO
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};

export const getOrderSchedule = async (id: number) => {
  try {
    const response = await account.get(`/orders/${id}/schedule`);
    return camelize(response, true);
  } catch (error) {
    // @ts-expect-error TODO
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};
